import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { api } from 'lib/httpClient';
import { ApiResponse } from 'further-types/api';
import { PaymentExpectationApi } from 'further-types/payment';
import { QUERY_STALE_TIME_MS } from 'further-ui/config';

export default function useOutstandingPayments(params: {
  page: number;
  rowsPerPage: number;
  search?: string;
  dateFrom?: string;
  dateTo?: string;
}) {
  return useQuery<PaymentExpectationApi.GetOutstandingPaymentsResponse>({
    queryKey: ['outstanding-payment-expectations', params],
    queryFn: async () =>
      (
        await api.get<
          ApiResponse<PaymentExpectationApi.GetOutstandingPaymentsResponse>
        >('/payment-expectation/outstanding', {
          params,
        })
      ).data.data,
    placeholderData: keepPreviousData,
    staleTime: QUERY_STALE_TIME_MS,
  });
}
